// extracted by mini-css-extract-plugin
export default {"label":"SuperCheckbox_label__H98qd","checkbox":"SuperCheckbox_checkbox__gjKV8","spanClassName":"SuperCheckbox_spanClassName__dMgXD"};